
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.027 10.137a.796.796 0 00.373.486l1.53.885v1.761a.8.8 0 00.8.801h1.762l.884 1.53a.81.81 0 00.694.4c.14 0 .278-.036.401-.108L8 15.01l1.53.884a.801.801 0 001.094-.292l.883-1.53h1.761a.8.8 0 00.801-.801v-1.761l1.53-.885a.8.8 0 00.293-1.095L15.008 8l.885-1.528a.8.8 0 00-.293-1.094l-1.53-.885V2.731a.801.801 0 00-.8-.8h-1.762L10.624.4a.807.807 0 00-.798-.394.795.795 0 00-.296.1L8 .992 6.47.107A.801.801 0 005.376.4l-.884 1.53H2.731a.801.801 0 00-.801.8v1.762L.4 5.376a.803.803 0 00-.293 1.096L.992 8 .107 9.528a.808.808 0 00-.08.61zM8 8.801c-2.788 0-3.204-1.505-3.204-2.403 0-1.03.824-2.069 2.403-2.335v-.86H8.8v.89c1.39.327 1.923 1.483 1.923 2.305h-.801l-.801.015C9.11 6.108 8.949 5.597 8 5.597c-1.041 0-1.602.413-1.602.801 0 .3 0 .801 1.602.801 2.787 0 3.204 1.505 3.204 2.403 0 1.031-.825 2.07-2.404 2.335v.87H7.2v-.866c-1.874-.294-2.403-1.604-2.403-2.339h1.602c.008.115.127.801 1.602.801 1.105 0 1.601-.468 1.601-.8 0-.261 0-.802-1.601-.802z"}})])
          )
        }
      }
    